module.exports = __webpack_public_path__ + "img/close-square.2c81a37e.svg";